function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import { CLICKABLE_REGION_REGEX } from '../util';
import MCPOption from './multiple_choice_poll_option';
import _ from 'underscore';
var FLOATING_POINT_REGEX = /^-?\d{0,3}(\.\d{1,2})?$/; // @namespace Model

var ClickableImageRegion = /*#__PURE__*/function (_MCPOption) {
  _inheritsLoose(ClickableImageRegion, _MCPOption);

  function ClickableImageRegion() {
    return _MCPOption.apply(this, arguments) || this;
  }

  var _proto = ClickableImageRegion.prototype;

  _proto.initialize = function initialize() {
    var _this = this;

    _MCPOption.prototype.initialize.apply(this, arguments);

    return this.on('change:value', function () {
      return delete _this.regionMatches;
    });
  }
  /*
   * Validate the points are numeric
   *
   */
  ;

  _proto.validate = function validate(attrs) {
    if (attrs.points && !FLOATING_POINT_REGEX.test(attrs.points)) {
      return 'Invalid points';
    }
  };

  _proto.contains = function contains(value) {
    var region = new ClickableImageRegion({
      value: value + '|0.1%x0.1%'
    });
    return this.overlaps(region);
  };

  _proto.resolveOverlaps = function resolveOverlaps(regions) {
    var _this2 = this;

    return regions.each(function (region) {
      if (_this2.overlaps(region)) {
        _this2.separateFrom(region);

        return _this2.trigger('reposition');
      }
    });
  };

  _proto.revertIfInvalid = function revertIfInvalid(toPosition) {
    var _this3 = this;

    var invalid = false;
    this.collection.collidableRegions(this).each(function (region) {
      var invalidPlacement = _this3.overlaps(region) || _this3.outsideContainer();

      if (invalidPlacement) {
        _this3.set({
          value: toPosition
        });

        _this3.trigger('reposition');

        invalid = true;
      }
    });
    return invalid;
  };

  _proto.outsideContainer = function outsideContainer() {
    var b = this.bounds();
    return b.left < 0 || b.right > 100 || b.top < 0 || b.bottom > 100;
  };

  _proto.isOtherRegion = function isOtherRegion() {
    return this.get('value') === ClickableImageRegion.CLICKABLE_REGION_OTHER;
  };

  _proto.containsRelativeXY = function containsRelativeXY(relativeX, relativeY, imageWidth, imageHeight) {
    if (this.isOtherRegion()) {
      return false;
    } else {
      // convert to absolutes now
      var targetX = relativeX * imageWidth;
      var targetY = relativeY * imageHeight;
      var regionX = this.relativeX() / 100 * imageWidth;
      var regionY = this.relativeY() / 100 * imageHeight;
      var regionWidth = this.relativeWidth() / 100 * imageWidth;
      var regionHeight = this.relativeHeight() / 100 * imageHeight;
      var insideX = targetX > regionX && targetX < regionX + regionWidth;
      var insideY = targetY > regionY && targetY < regionY + regionHeight;
      return insideX && insideY;
    }
  };

  _proto.relativeWidth = function relativeWidth() {
    if (this.regionMatches == null) {
      this.regionMatches = __guard__(this.get('value'), function (x) {
        return x.match(CLICKABLE_REGION_REGEX);
      });
    }

    if ((this.regionMatches != null ? this.regionMatches.length : undefined) > 4) {
      return parseFloat(this.regionMatches[4]);
    }
  };

  _proto.relativeHeight = function relativeHeight() {
    if (this.regionMatches == null) {
      this.regionMatches = __guard__(this.get('value'), function (x) {
        return x.match(CLICKABLE_REGION_REGEX);
      });
    }

    if ((this.regionMatches != null ? this.regionMatches.length : undefined) > 5) {
      return parseFloat(this.regionMatches[5]);
    }
  };

  _proto.respondWithCoord = function respondWithCoord(relativeX, relativeY) {
    return this.respond("region: " + relativeX * 100 + "%," + relativeY * 100 + "%");
  };

  _proto.center = function center() {
    return {
      x: this.relativeX() + this.relativeWidth() / 2,
      y: this.relativeY() + this.relativeHeight() / 2
    };
  };

  _proto.size = function size() {
    return {
      width: this.relativeWidth(),
      height: this.relativeHeight()
    };
  };

  _proto.bounds = function bounds() {
    return {
      left: this.relativeX(),
      right: this.relativeX() + this.relativeWidth(),
      top: this.relativeY(),
      bottom: this.relativeY() + this.relativeHeight()
    };
  };

  _proto.overlaps = function overlaps(region) {
    // The "other" region has no XY coordinates. Thus it never overlaps.
    if (region.isOtherRegion() || this.isOtherRegion()) {
      return false;
    }

    var _this$bounds = this.bounds(),
        l1 = _this$bounds.left,
        r1 = _this$bounds.right,
        t1 = _this$bounds.top,
        b1 = _this$bounds.bottom;

    var _region$bounds = region.bounds(),
        l2 = _region$bounds.left,
        r2 = _region$bounds.right,
        t2 = _region$bounds.top,
        b2 = _region$bounds.bottom;

    return !(l2 > r1 || r2 < l1 || t2 > b1 || b2 < t1);
  };

  _proto.separateFrom = function separateFrom(region) {
    var direction = 1.05;

    var _region$size = region.size(),
        rWidth = _region$size.width,
        rHeight = _region$size.height;

    var _region$center = region.center(),
        rX = _region$center.x,
        rY = _region$center.y;

    var _this$size = this.size(),
        width = _this$size.width,
        height = _this$size.height;

    var _this$center = this.center(),
        x = _this$center.x,
        y = _this$center.y;

    var _this$bounds2 = this.bounds(),
        left = _this$bounds2.left,
        top = _this$bounds2.top;

    var overlapX = (width + rWidth) / 2 - Math.abs(x - rX);
    var overlapY = (height + rHeight) / 2 - Math.abs(y - rY);

    if (overlapY > overlapX) {
      if (x <= rX) {
        direction = -direction;
      }

      left += direction * overlapX;
      return this.updateValue({
        x: left
      });
    } else {
      if (y <= rY) {
        direction = -direction;
      }

      top += direction * overlapY;
      return this.updateValue({
        y: top
      });
    }
  };

  _proto.updateValue = function updateValue(_ref) {
    var x = _ref.x,
        y = _ref.y,
        width = _ref.width,
        height = _ref.height,
        name = _ref.name;
    var bounds = this.bounds();
    var size = this.size();

    if (x == null) {
      x = bounds.left;
    }

    if (y == null) {
      y = bounds.top;
    }

    if (width == null) {
      width = size.width;
    }

    if (height == null) {
      height = size.height;
    }

    if (name == null) {
      name = this.getName();
    }

    return this.set({
      value: "region: " + x + "%," + y + "%|" + width + "%x" + height + "%#" + name
    }); // eslint-disable-line no-useless-escape
  };

  _proto.setName = function setName(name) {
    var value = this.get('value');
    this.set({
      value: value.replace(/#.*$/, '') + ("#" + name)
    }); // eslint-disable-line no-useless-escape

    return this.trigger('rename');
  };

  _proto.getName = function getName() {
    if (this.regionMatches == null) {
      this.regionMatches = __guard__(this.get('value'), function (x) {
        return x.match(CLICKABLE_REGION_REGEX);
      });
    }

    if ((this.regionMatches != null ? this.regionMatches.length : undefined) > 5) {
      return this.regionMatches[6];
    }
  };

  _proto.toJSON = function toJSON() {
    return _.pick(this.attributes, '_destroy', 'id', 'value', 'correct_response', 'points');
  };

  _createClass(ClickableImageRegion, null, [{
    key: "CLICKABLE_REGION_OTHER",
    get: function get() {
      return 'region:other';
    }
  }, {
    key: "CLICKABLE_REGION_DEFAULT_WIDTH",
    get: function get() {
      return 65;
    }
  }, {
    key: "CLICKABLE_REGION_DEFAULT_HEIGHT",
    get: function get() {
      return 65;
    }
  }, {
    key: "CLICKABLE_REGION_MIN_WIDTH",
    get: function get() {
      return 20;
    }
  }, {
    key: "CLICKABLE_REGION_MIN_HEIGHT",
    get: function get() {
      return 20;
    } // For backwards compatability, moved to Util to resolve circular dep in _images

  }, {
    key: "CLICKABLE_REGION_REGEX",
    get: function get() {
      return CLICKABLE_REGION_REGEX;
    }
  }]);

  return ClickableImageRegion;
}(MCPOption);

export { ClickableImageRegion as default };

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}